/* Back from Google / Microsoft / Apple: brightivity.dev/auth/{p}/callback → /auth/callback#token=…&new=1&key=… (or #error=…).
 * Also the key-request email button: brightivity.dev/auth/claim/<token> → #token=…&method=claim (no new/mismatch) →
 * /onboarding when not onboarded, else / (pending-signups.md); a used link → #error=…
 * The token is in the URL fragment, never sent to a server. */
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, setSession } from '../api/client.js';
import { Button, Card, Spinner } from '../ui/index.jsx';
import { SignupDone } from './SignInPage.jsx';
import '../app/shell.css';
import '../features/auth/auth.css';
import { useTranslation } from 'react-i18next';

export default function AuthCallbackPage() {
  const { t } = useTranslation('bv');
  const navigate = useNavigate();
  const [state, setState] = useState({ busy: true });
  useEffect(() => {
    const h = new URLSearchParams(window.location.hash.slice(1));
    window.history.replaceState(null, '', '/auth/callback'); // drop the token from the address bar
    if (h.get('error')) { setState({ error: h.get('error') }); return; }
    const token = h.get('token');
    if (!token) { setState({ error: t('auth.cb.notFinished') }); return; }
    setSession({ token });
    api('/auth/me').then((r) => {
      if (!r.ok) { setSession(null); setState({ error: r.error || t('auth.su.failedIn') }); return; }
      setSession({ token, userId: r.data.userId, email: r.data.email, name: r.data.name, ...r.data });
      if (h.get('new') || h.get('mismatch')) { setState({ done: { isNew: !!h.get('new'), key: h.get('key'), onboarding: r.data.onboardingCompleted }, method: h.get('method') }); return; }
      navigate(r.data.onboardingCompleted === false ? '/onboarding' : '/', { replace: true });
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="bv-signin">
      <Card className="bv-signin__card" pad={false}>
        <img className="bv-signin__logo" src="/brand/logo-long-on-light.svg" alt="Brightivity" />
        {state.busy && <p className="bv-signin__sub" role="status"><Spinner label={t('auth.signingIn')} /> {t('auth.cb.signingYouIn')}</p>}
        {state.error && (
          <div data-testid="callback-error">
            <h1 className="bv-signin__title">{t('auth.cb.title')}</h1>
            <p className="bv-signin__msg bv-signin__msg--err" role="alert">{state.error}</p>
            <Button variant="coral" block style={{ height: 52 }} onClick={() => navigate('/sign-in', { replace: true })}>{t('auth.cb.back')}</Button>
          </div>
        )}
        {state.done && <SignupDone done={state.done} method={state.method} onGo={() => navigate(state.done.onboarding === false ? '/onboarding' : '/', { replace: true })} />}
      </Card>
    </div>
  );
}
